import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

/* 布局模块 */
import Layout from '@/layout'
import Blank from '@/layout/blank'
import { isOS } from '../utils/constant'

/**
 * Note: 子菜单数 > 1 时出现子菜单
 *
 * hidden: true                   设为 true，则该路由不会再侧边栏出现，如401，login等页面
 * alwaysShow: true               设为 true，则默认总出现根路由，不展开子路由
 * redirect: noRedirect           设为 noRedirect 则该路由在面包屑导航中不可被点击
 * name:'router-name'             设定路由的名字，一定要填写不然使用<keep-alive>时会出现各种问题
 * meta : {
    types : [1,2,3],                个人（1），月结（2）,超级管理员(3)----3超级管理员菜单已下掉，路由注释
    roles: ['admin','editor']     权限
    title: 'title'                侧边栏和面包屑中名字
    icon: 'svg-name'              图标
    breadcrumb: false             设为 false，不会在面包屑中显示
    activeMenu: '/example/list'   高亮侧边栏名字
    enable:false,                 企业账号的基本资料是否启用
    bottomFixed: false            设为true，动态给路由底部的Copyright添加margin-bottom：85px，如订单查看的返回列表固定定位
  }
 */

/**
 * 无鉴权通用路由
 */
export const constantRoutes = [
  {
    path: '/replacetoken',
    component: Blank,
    hidden: true,
    children: [
      {
        path: '/replacetoken/',
        component: () => import('@/views/user/replacetoken/index'),
      }
    ]
  },
  // 提供专门展示具体协议页面/terms?termType=4&siteCountryCode=CN&lang=zh-CN&version=xx
  {
    path: '/terms',
    name: 'terms',
    hidden: true,
    component: () => import('@/components/termsBox'),
  },
  // {
  //   path: '/preloading',
  //   component: Blank,
  //   hidden: true,
  //   children: [
  //     {
  //       path: '/preloading/',
  //       component: () => import('@/views/user/preloading/index'),
  //     }
  //   ]
  // },
  // 重定向
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path*',
        component: () => import('@/views/redirect/index')
      }
    ]
  },
  // ICAS - 自动登录加载界面
  {
    path: '/logining',
    name: 'Logining',
    hidden: true,
    component: () => import('@/components/LoginRegisterBox')
  },
  {
    path: '/preloading',
    name: 'preloading',
    component: () => import('@/views/user/preloading/index'),
  },
  // 鉴权中间页
  {
    path: '/authorize',
    name: 'authorize',
    component: () => import('@/views/user/authorize/index'),
  },
  // 重定向到 IUOP - 登录
  {
    path: '/',
    name: '/',
    component: () => import('@/components/LoginRegisterBox')
  },
  // IUOP - 注册
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/components/LoginRegisterBox')
  },
  // IUOP - 新登录
  {
    path: '/login',
    name: 'Login',
    redirect: '/',
    component: () => import('@/components/LoginRegisterBox')
  },
  // {
  //   path: '/loginApp',
  //   name: 'LoginApp',
  //   redirect: '/',
  // },
  // IUOP - 旧登录
  {
    path: '/old-login',
    // name: 'OldLogin',
    redirect: '/',
    // component: () => import('@/components/LoginRegisterBox')
  },
  // IUOP - 忘记密码
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: () => import('@/components/LoginRegisterBox')
  },
  // 账号信息确认
  {
    path: '/account-conflict',
    name: 'AccountConflict',
    component: () => import('@/views/accountConflict')
  },
  // SFBUY - 修改密码
  {
    path: '/sys/change-password',
    name: 'ChangePasswordBuy',
    hidden: true,
    component: () => import('@/views/sys/change-password'),
    meta: {
      title: 'ChangePassword'
    }
  },
  // SFBUY - 绑定邮箱
  {
    path: '/sys/binding-email',
    name: 'BindingEmailBuy',
    hidden: true,
    component: () => import('@/views/sys/binding-email'),
    meta: {
      title: 'BindingEmail'
    }
  },
  // SFBUY - 修改邮箱
  {
    path: '/sys/change-email',
    name: 'ChangeEmailBuy',
    hidden: true,
    component: () => import('@/views/sys/change-email'),
    meta: {
      title: 'ChangeEmail'
    }
  },
  // SFBUY - 绑定手机
  {
    path: '/sys/binding-phone',
    name: 'BindingPhoneBuy',
    hidden: true,
    component: () => import('@/views/sys/binding-phone'),
    meta: {
      title: 'BindingPhone'
    }
  },
  // SFBUY - 修改手机
  {
    path: '/sys/change-phone',
    name: 'ChangePhoneBuy',
    hidden: true,
    component: () => import('@/views/sys/change-phone'),
    meta: {
      title: 'ChangePhone'
    }
  },
  // SFBUY - 设置用户名
  {
    path: '/sys/set-name',
    name: 'SetName',
    hidden: true,
    component: () => import('@/views/sys/name'),
    meta: {
      title: 'Name'
    }
  },
  // SFBUY - 注销账号
  {
    path: '/sys/cancel-account',
    name: 'CancelAccountBuy',
    hidden: true,
    component: () => import('@/views/sys/cancel-account'),
    meta: {
      title: 'CancelAccount'
    }
  },
  {
    path: '/icas/user/account-security',
    name: 'IcasAccountSecurity',
    component: () => import('@/views/user/account-security/index'),
    hidden: true,
    meta: {
      title: 'AccountSecurity',
    }
  },
  {
    path: '/icas/user/guide',
    name: 'guide',
    component: () => import('@/views/user/guide/index'),
    hidden: true,
    meta: {
      title: 'guide',
    }
  },
  {
    path: '/icas/user/change-password',
    name: 'IcasChangePassword',
    component: () => import('@/views/user/account-security/change-password/index'),
    hidden: true,
    meta: {
      title: 'AccountSecurity',
    }
  },
  {
    path: '/icas/user/message-notice',
    name: 'IcasMessageNotice',
    component: () => import('@/views/user/account-security/message-notice/index'),
    hidden: true,
    meta: {
      title: 'AccountSecurity',
    }
  },
  {
    path: '/icas/user/phone',
    name: 'IcasPhone',
    component: () => import('@/views/user/account-security/phone/index'),
    hidden: true,
    meta: {
      title: 'AccountSecurity',
    }
  },
  {
    path: '/icas/user/email',
    name: 'IcasEmail',
    component: () => import('@/views/user/account-security/email/index'),
    hidden: true,
    meta: {
      title: 'AccountSecurity',
    }
  },
  {
    path: '/icas/user/name',
    name: 'IcasName',
    component: () => import('@/views/user/account-security/name/index'),
    hidden: true,
    meta: {
      title: 'AccountSecurity',
    }
  },
  {
    path: '/icas/user/realname',
    name: 'IcasRealname',
    component: () => import('@/views/user/account-security/realname/index'),
    hidden: true,
    meta: {
      title: 'AccountSecurity',
    }
  },
  {
    path: '/icas/user/cancel-account',
    name: 'IcasCancelAccount',
    component: () => import('@/views/user/account-security/cancel-account/index'),
    hidden: true,
    meta: {
      title: 'AccountSecurity',
    }
  },
  // 激活邮件-设置密码
  // {
  //   path: '/email-link',
  //   name: 'EmailLink',
  //   component: () => import('@/views/email-link/index')
  // },
  {
    path: '/404',
    component: () => import('@/views/404'),
    hidden: true
  }
]

const accountSecurityTitle = isOS() ? 'AccountSecurity' : 'AccountSetting'

/**
 * 需要鉴权的路由
 */
export const asyncRoutes = [
  {
    path: '/guide',
    component: Layout,
    name: 'User',
    redirect: '/guide/guide',
    meta: { title: '顺丰国际产品导航', icon: 'ic_menu', types: [4] },
    isNest: true,
    // first: true,
    children: [
      {
        isNest: true,
        hidden: true,
        path: 'guide',
        name: 'guide',
        component: () => import('@/views/user/guide/index'),
        meta: {
          title: '顺丰国际产品导航',
          types: [4]
        }
      },
    ]
  },
  // {
  //   path: '/icas/user/guide',
  //   // component: Layout,
  //   name: 'guide',
  //   // redirect: '/user/base-info',
  //   component: () => import('@/views/user/account-security/index'),
  //   meta: { title: 'permission', icon: 'menu-user', types: [1, 2] },
  // },
  // 我的资料
  {
    path: '/user',
    component: Layout,
    name: 'User',
    redirect: '/user/base-info',
    meta: { title: 'MyInfomation', icon: 'menu-user', types: [1, 2] },
    children: [
      // 账号安全
      {
        path: 'account-security',
        name: 'AccountSecurity',
        component: () => import('@/views/user/account-security/index'),
        meta: {
          title: accountSecurityTitle,
          types: [1, 2]
        }
      },
      // 账号安全 - 修改密码
      {
        path: 'change-password',
        name: 'ChangePassword',
        component: () => import('@/views/user/account-security/change-password/index'),
        hidden: true,
        meta: {
          title: 'ChangePassword',
          activeMenu: '/user/account-security',
          types: [1, 2]
        }
      },
      // 账号安全 -- 绑定手机或修改手机
      {
        path: 'phone',
        name: 'Phone',
        component: () => import('@/views/user/account-security/phone/index'),
        hidden: true,
        meta: {
          title: accountSecurityTitle,
          activeMenu: '/user/account-security',
          types: [1, 2]
        }
      },
      // 营销通知修改
      {
        path: 'message-notice',
        name: 'messageNotice',
        component: () => import('@/views/user/account-security/message-notice/index'),
        hidden: true,
        meta: {
          title: accountSecurityTitle,
          activeMenu: '/user/message-notice',
          types: [1, 2]
        }
      },
      // 账号安全 -- 绑定邮箱或修改邮箱
      {
        path: 'email',
        name: 'Email',
        component: () => import('@/views/user/account-security/email/index'),
        hidden: true,
        meta: {
          title: accountSecurityTitle,
          activeMenu: '/user/account-security',
          types: [1, 2]
        }
      },
      // 账号安全 -- 设置用户名
      {
        path: 'name',
        name: 'Name',
        component: () => import('@/views/user/account-security/name/index'),
        hidden: true,
        meta: {
          title: 'Name',
          activeMenu: '/user/account-security',
          types: [1, 2]
        }
      },
      // SFBUY - 设置用户名
      {
        path: 'realname',
        name: 'Realname',
        hidden: true,
        component: () => import('@/views/user/account-security/realname/index'),
        meta: {
          title: 'Name',
          activeMenu: '/user/account-security',
          types: [1, 2]
        }
      },
      // 账号安全 -- 账号注销
      {
        path: 'cancel-account',
        name: 'CancelAccount',
        component: () => import('@/views/user/account-security/cancel-account/index'),
        hidden: true,
        meta: {
          title: accountSecurityTitle,
          activeMenu: '/user/account-security',
          types: [1, 2]
        }
      },
      // 签署管理
      {
        path: '/protocol',
        name: 'Protocol',
        component: () => import('@/views/user/protocol/index'),
        meta: {
          title: 'ProtocolManage'
        }
      },
    ]
  },
  // {
  //   path: '/permission',
  //   component: Layout,
  //   name: 'Permission',
  //   redirect: '/permission/permission',
  //   meta: { title: 'permission', icon: 'menu-user', types: [3] },
  //   children: [
  //     // 系统管理
  //     {
  //       path: 'system', name: 'permission_system', component: () => import('@/views/permission/System'),
  //       meta: { title: 'permission_system', types: [3] }
  //     },
  //     // 角色管理
  //     {
  //       path: 'roles', name: 'permission_role', component: () => import('@/views/permission/Role'),
  //       meta: { title: 'permission_role', types: [3] }
  //     },
  //     // 资源权限
  //     {
  //       path: 'resource', name: 'permission_resource', component: () => import('@/views/permission/Resource'),
  //       meta: { title: 'permission_resource', types: [3] }
  //     },
  //     // 用户管理
  //     {
  //       path: 'user', name: 'permission_user', component: () => import('@/views/permission/User'),
  //       meta: { title: 'permission_user', types: [3] }
  //     },
  //   ]
  // },
  // 404 路由固定放置最末位置
  { path: '*', redirect: '/404', hidden: true }
]

const createRouter = () => new Router({
  // mode: 'history', // 需要后台配置支持
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

// 重置路由
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
}

export default router
